import {PayloadAction} from '@reduxjs/toolkit'
import {call, put, takeLatest} from 'redux-saga/effects'
import {
  getAllActiveSettingReference,
  setAllActiveSettingReference,
  setTransactionFail,
} from './sharedRedux'

import {HTTP_CODE} from '../constants'
import {ResponseGenerator} from '../models/ResponseGenerator'
import {getAllActiveSetting} from '../../pages/setting-reference/redux/SettingReferenceAPIs'

export default function* saga() {
  /**
   * getAllSystemReference
   */
  yield takeLatest(
    getAllActiveSettingReference.type,
    function* getAllSystemReference(action: PayloadAction<number>) {
      try {
        const serviceId = action.payload
        if (serviceId === undefined || serviceId === null) {
          throw new Error('Service id is required to load active settings')
        }
        const response: ResponseGenerator = yield call(getAllActiveSetting, serviceId)
        if (response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setAllActiveSettingReference(response.data))
      } catch (error: any) {
        yield put(setTransactionFail(error.message))
      }
    }
  )
}
